<template>
  <v-list dense style="padding-top: 0px !important;">
    <v-subheader>
      {{ landEntity.name.toLowerCase() }} info
    </v-subheader>
    <template v-for="tab in this.tabs">
      <v-list-item :key="tab"
                   :to="`/document-management/land-entities/${landEntity.facilityId}/${tab}`">
        <v-list-item-icon>
          <v-icon dense>mdi-magnify</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ tab.replace('-', ' ').toLowerCase() }}</v-list-item-title>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "LandEntityLinksDetails",
  props: {
    facilityId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    landEntity: {facilityId: '', name: ''},
    tabs: [
      'projects',
      'documents'
    ]
  }),

  apollo: {
    landEntity: {
      query: gql`query ($landEntityId: String!){
          landEntity(where: {facilityId: {eq: $landEntityId}}){
              facilityId
              name
              building,
              type
          }
      }`,
      update: data => data.landEntity[0] || null,
      variables() {
        return {
          landEntityId: this.facilityId
        }
      }
    }
  }
}
</script>

<style scoped>
.v-list-item__icon {
  height: 24px;
  margin: 0px;
  margin-right: .5em !important;
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 20px;
  height: 24px;
  margin-bottom: 1px;
}

.v-list-item__title {
  font-weight: 400 !important;
}
</style>
